import { useState as s, useEffect as c } from "react";
function a() {
  const [o, r] = s(!1), [d, u] = s(0);
  return c(() => {
    if (typeof window > "u") return;
    const t = () => {
      const n = window.innerWidth;
      u(n), r(n > 991);
    };
    let e;
    const i = () => {
      clearTimeout(e), e = setTimeout(t, 500);
    };
    return t(), window.addEventListener("resize", i), () => {
      window.removeEventListener("resize", i), clearTimeout(e);
    };
  }, []), { isDesktop: o, clientWidth: d };
}
export {
  a as u
};
